import angular from 'angular';

import CategoryComponent from './category.cmpt';

export default angular
    .module('application.component.modals.component.category', [])
    .component(CategoryComponent.selector, CategoryComponent);



// WEBPACK FOOTER //
// ./src/application/component/modals/component/category/index.js